export const LogoPath = './assets/media/logos/logo-dark.svg';
export const UserimgPath = './assets/media/users/';
export const EditIconPath = './assets/media/svg/icons/Communication/Write.svg';
export const CloseIconPath = './assets/media/svg/icons/Navigation/Close.svg';
export const UserIconPath = './assets/media/svg/icons/General/User.svg';
export const PwdIconPath = './assets/media/svg/icons/General/Shield-protected.svg';
export const TwofaIconPath = './assets/media/svg/icons/General/Shield-check.svg';
export const CommunicationPath = './assets/media/svg/icons/Communication/Sending mail.svg';
export const ChatIconPath = './assets/media/svg/icons/Communication/Chat2.svg';
export const StartIconPath = './assets/media/svg/icons/Media/Play.svg';
export const ResumeIconPath = './assets/media/svg/icons/Media/Repeat.svg';
export const StopIconPath = './assets/media/svg/icons/Code/Stop.svg';
export const TelconsultIconPath = './assets/media/svg/icons/Media/teleconsult.svg';